import React, { useCallback, useEffect, useMemo } from 'react';
import Section from 'design-system/Section';
import { CardView } from 'design-system/CardView';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { makeSelectTransactionById } from 'features/transactions/selectors';
import { getLinkedTransaction } from 'actions';
import { formatPlural } from 'utils';
import { styles } from './styles';
import RowTransaction from '../RowTransaction';
const TransactionLinkedTransactionSection = ({ transaction, }) => {
    const memoSelectTransactionByIdForLinked = useMemo(makeSelectTransactionById, []);
    const linkedTransactionId = 'relatedTransactionId' in transaction
        ? transaction.relatedTransactionId
        : undefined;
    const relatedSmartRuleTransactionId = 'smartRuleInfo' in transaction &&
        transaction.smartRuleInfo &&
        'relatedTransactionId' in transaction.smartRuleInfo
        ? transaction.smartRuleInfo.relatedTransactionId
        : undefined;
    const linkedTransaction = useAppSelector((store) => memoSelectTransactionByIdForLinked(store, linkedTransactionId));
    const relatedSmartRuleTransaction = useAppSelector((store) => memoSelectTransactionByIdForLinked(store, relatedSmartRuleTransactionId));
    const dispatch = useAppDispatch();
    const navigation = useMainStackNavigation();
    useEffect(() => {
        if (linkedTransactionId) {
            dispatch(getLinkedTransaction(linkedTransactionId));
        }
        if (relatedSmartRuleTransactionId) {
            dispatch(getLinkedTransaction(relatedSmartRuleTransactionId));
        }
    }, [linkedTransactionId, relatedSmartRuleTransactionId]);
    const openLinked = useCallback((id) => {
        const navState = navigation.getState();
        const prevRoute = navState.routes[navState.index - 1];
        if (prevRoute.name === 'Item' &&
            prevRoute.params?.id === id) {
            navigation.pop();
        }
        else {
            navigation.push('Item', { id });
        }
    }, []);
    if (!linkedTransaction && !relatedSmartRuleTransaction) {
        return null;
    }
    return (<Section title={formatPlural('Linked transaction', 'Linked transactions', linkedTransaction && relatedSmartRuleTransaction ? 2 : 1)} style={styles.section}>
      <CardView noMarginTop noMarginBottom webPadding>
        {linkedTransaction ? (<RowTransaction backgroundDark onPress={() => openLinked(linkedTransaction.id)} item={linkedTransaction}/>) : null}
        {relatedSmartRuleTransaction ? (<RowTransaction backgroundDark onPress={() => openLinked(relatedSmartRuleTransaction.id)} item={relatedSmartRuleTransaction}/>) : null}
      </CardView>
    </Section>);
};
export default TransactionLinkedTransactionSection;
